import styled from 'styled-components';
import device from '../../../../GlobalDigitalStyle/BreakPoint.style';

export const TeamStatisticsContainer = styled.div`
	height: 20em;
	@media ${device.screen1680} {
		height: 18em;
	}
	@media ${device.screen1366} {
		height: 16em;
	}
	@media ${device.screen1280} {
		height: 14em;
	}
	@media ${device.screen1050} {
		height: 12em;
	}
	.team__stats__img {
	}
	.team__stats__content {
		gap: 0.7em;
		.team__stats__header {
			line-height: normal;
			font-size: 17px;
			@media ${device.screen1680} {
				font-size: 16px;
			}
			@media ${device.screen1280} {
				font-size: 14.8px;
			}
			@media ${device.screen1050} {
				font-size: 13px;
			}
		}
	}
	.text__default {
		font-weight: 600;
		font-size: 15px;
		@media ${device.screen1680} {
			font-size: 14px;
		}
		@media ${device.screen1280} {
			font-size: 12.8px;
		}
		@media ${device.screen1050} {
			font-size: 11px;
		}
	}
`;
